import { render, staticRenderFns } from "./ProfileRegionAndGroupInfos.vue?vue&type=template&id=0870766c&scoped=true"
import script from "./ProfileRegionAndGroupInfos.vue?vue&type=script&lang=js"
export * from "./ProfileRegionAndGroupInfos.vue?vue&type=script&lang=js"
import style0 from "./ProfileRegionAndGroupInfos.vue?vue&type=style&index=0&id=0870766c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0870766c",
  null
  
)

export default component.exports